import {
  Box,
  Button,
  ButtonGroup,
  Icon,
  ListItem,
  Typography,
} from "@mui/material";

import { IconCloudDownload, IconLoader, IconTrashX } from "@tabler/icons-react";
import { useUsuario } from "../../../../providers/usuarioProvider";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import UploadInternacional from "../../../../models/uploadInternacional";
import { deleteDoc } from "firebase/firestore";
import UploadInternacionalDb from "../../../../db/uploadInternacionalDb";

type Props = {
  upload: UploadInternacional;
};

export default function StatementImportando({ upload }: Props) {
  const { visualizado } = useUsuario();

  return (
    <ListItem disableGutters sx={{ px: 2, py: 1 }}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        width="100%"
      >
        <Icon
          fontSize="inherit"
          sx={(theme) => ({
            width: 16,
            // Accent como TINTA — `primary.main` sobre superfície escura
            // reprova em contraste (DESIGN.md → accent vs. accent-ink).
            color: theme.palette.accentInk,
            display: "inline-flex",
            animation: "felix-sync-spin 1.4s linear infinite",
            "@keyframes felix-sync-spin": {
              from: { transform: "rotate(0deg)" },
              to: { transform: "rotate(360deg)" },
            },
          })}
        >
          <IconLoader size={16} strokeWidth={3} />
        </Icon>
        <Box display="flex" flexGrow={1} px={1}>
          <Typography
            variant="body1"
            fontWeight={600}
            sx={(theme) => ({ color: theme.palette.accentInk })}
          >
            Importando statement (
            <Typography
              variant="dataMono"
              component="span"
              color="text.secondary"
            >
              {upload.nomeArquivoOriginal}
            </Typography>
            )...
          </Typography>
        </Box>
        <ButtonGroup size="small" variant="outlined">
          <Button
            color="info"
            size="small"
            onClick={async () =>
              await getDownloadURL(
                ref(
                  getStorage(),
                  `/usuarios/${visualizado}/uploadsInternacionais/${upload.id}`
                )
              ).then((url) => window.open(url))
            }
          >
            <IconCloudDownload size={16} />
          </Button>
          <Button
            color="error"
            size="small"
            onClick={async () => {
              if (!!visualizado)
                await deleteDoc(
                  new UploadInternacionalDb().doc({
                    usuarioId: visualizado,
                    uploadId: upload.id,
                  })
                );
            }}
          >
            <IconTrashX size={16} />
          </Button>
        </ButtonGroup>
      </Box>
    </ListItem>
  );
}
